import * as yup from 'yup';

export const permissionGroupYupSchema = yup.object().shape({
  name: yup.string(),
});
